import gql from 'graphql-tag';

export const GET_TABLE_FILTERS = gql`
  query GetTableFilters($tableType: FilterTableType!) {
    tableFilter {
      tableFilters(tableType: $tableType) {
        error
        success
        data {
          tableFilterId
          name
          isDefault
          config
        }
      }
    }
  }
`;
